import styled from 'styled-components'

const colorSelector = props => (props.error ? '#e6000f' : '#008c5d')

export const Container = styled.div`
  padding: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 6px 15px 5px rgba(182, 187, 200, 0.2), inset 0 -1px 0 rgba(182, 187, 200, 0.25);
  border-radius: 8px;
  border: 1px solid #ebedf0;
  background: #fff;

  @media (min-width: 576px) {
    padding: 20px 40px;
  }

  .text {
    width: 216px;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;

    @media (min-width: 576px) {
      width: 324px;
    }
  }
  .close {
    & {
      right: 12px;
      top: 15px;

      @media all and (-ms-high-contrast: none) {
        top: 0;
      }
    }

    @media (min-width: 1024px) {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .line {
    position: absolute;
    top: 0;
    right: 0;
    height: 3px;
    background-color: ${colorSelector};
    width: 100%;
  }
  svg {
    fill: ${colorSelector};
    margin-right: 10px;
  }
`

export const B = styled.span`
  font-weight: 700;
`
